import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoModal } from 'vl-common/src/components/Modals';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import useSessionFlagMutation from '@hooks/useSessionFlagMutation';
import ConfluenceArticle from '@components/UI/ConfluenceArticle';
import ClinicalCheckbox from '@components/Clinicians/Session/Components/ClinicalCheckbox';
import { Button } from 'antd';

const ComplexCaseFormItem = () => {
  const { t } = useTranslation('common');

  const {
    appointment: { read_only: readOnly, appointment_completed: isCompleted }
  } = useSessionAppointment();

  const [complexCaseModalOpen, setShowComplexCaseModalOpen] = useState(false);

  const { mutate: handleFlagChange, isPending: flagsSaving } = useSessionFlagMutation({ field: 'complex_case' });

  const handleOpenComplexCaseModal = (open: boolean) => setShowComplexCaseModalOpen(open);

  return (
    <>
      <ClinicalCheckbox
        field="complex_case"
        label={t('clinicalComplexCaseLabel')}
        disabled={!!readOnly || !!isCompleted || flagsSaving}
        isSaving={flagsSaving}
        onChange={handleFlagChange}
        helpLink={
          <Button data-testid="define-complex-case-button" type="link" onClick={() => handleOpenComplexCaseModal(true)}>
            {t('What defines a complex case?')}
          </Button>
        }
      />
      <InfoModal
        open={complexCaseModalOpen}
        data-testid="complex-case-modal"
        onOk={() => handleOpenComplexCaseModal(false)}
        okButtonProps={{ 'data-testid': 'complex-case-modal-close-button' }}
        okText="Close"
      >
        <ConfluenceArticle id="CONF_COMPLEX_PATIENT" />
      </InfoModal>
    </>
  );
};

export default ComplexCaseFormItem;
